export const XTS_EMAIL = 'talentservice@xing.com';

export enum PRODUCT_TYPES {
  longlist = 'longlist',
  shortlist = 'shortlist',
}

export const FEATURE_SWITCHES = {
  TRACKING_ENABLED: 'xss_tracking_enabled',
  QUICK_FEEDBACK_ENABLED: 'xts_easy_feedback_in_briefing',
  NEW_BRIEFING_DETAILS_ENABLED: 'xts_new_briefing_details',
  NEW_BRIEFING_FORM_ENABLED: 'xts_new_briefing_form',
  RECRUITING_SETTINGS: 'recruiting_settings_your_settings',
  TWELVE_WEEKS_SHORTLIST: 'xts_twelve_week_shortlist',
  XING_REBRANDING_ENABLED: 'dev_flag_xing_rebranding',
} as const;

export const LOCALE_EN = 'en';
export const LOCALE_DE = 'de';

export const MUTATION_FEEDBACK_TIME = 3000;

export const CONSUMER_APP = 'erecruiting-sourcing-service';

export const VIEW_WITHOUT_SIDEBAR_WIDTH = 1136;

export const DEBOUNCE_TIME = 350;

export const AUTOCOMPLETE_MIN_CHARS = 2;

export const CLOSE_DELAY = 100;

export const FORM_WIDTH = 672;
